import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import PaymentComplementReport from "../../components/paymentComplementReport";
import * as paymentComplementReportActions from "../../actions/paymentComplementReport";
import { showDocument } from "../../actions/documents";
import { errorNotification } from "../../../utils/notifications";
import {
  PaymentComplementReportFilters,
  PaymentComplementReportRow
} from "../../../types/PaymentComplementReport";

interface Props {
  report: PaymentComplementReportRow[];
  searching: boolean;
  getPaymentComplementReport: (filters: PaymentComplementReportFilters) => void;
  toggleBill: (storageId: number) => void;
}

/**
 * Container for the payment complements report screen.
 */
class PaymentComplementReportContainer extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Reporte complementos de pagos" />
        <Layout>
          <PaymentComplementReport
            report={this.props.report}
            searching={this.props.searching}
            getPaymentComplementReport={this.props.getPaymentComplementReport}
            toggleBill={this.props.toggleBill}
          />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { paymentComplementReport } = state;
  return {
    report: (paymentComplementReport && paymentComplementReport.report) || [],
    searching:
      (paymentComplementReport && paymentComplementReport.searching) || false
  };
};

const mapDispatchToProps = dispatch => ({
  getPaymentComplementReport: (filters: PaymentComplementReportFilters) => {
    dispatch(
      paymentComplementReportActions.getPaymentComplementReport(filters)
    );
  },
  toggleBill: (storageId: number) => {
    if (!storageId) {
      errorNotification(
        "El complemento no tiene PDF almacenado (pdfStorageId)"
      );
      return;
    }
    dispatch(showDocument(storageId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentComplementReportContainer);
